(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js'); "use strict";

const {
  sendView,
  setupClickInMbox
} = svs.components.adobeTargetPayloadHandler;
svs.components.dataAttribute.track('data-crm-mbox', element => {
  sendView(element);
  setupClickInMbox(element);
});
 })(window);